import React, { useRef } from 'react'
import { t } from 'i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faTimes, faUpload } from '@fortawesome/free-solid-svg-icons'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'

function QuickListFilters({
  searchText,
  status,
  loading,
  onSearchTextChange,
  onStatusChange,
  onClearSearch,
  onCreate,
  onToggleBulkUpload,
  bulkOperationInProgress,
}) {
  const searchInputRef = useRef(null)

  const handleClearSearch = () => {
    onClearSearch()
    searchInputRef.current?.focus()
  }

  return (
    <div
      className="quick-list-filters"
      data-testid="container-quick-list-filters">
      <Row className="quick-list-filters-row">
        <Col md={6} lg={4} className="quick-list-search-col">
          <div className="quick-list-search-field">
            <input
              ref={searchInputRef}
              type="text"
              className="form-control"
              data-testid="input-search-quick-list"
              placeholder={t('QUICK_LIST_SETTINGS.LIST.SEARCH_PLACEHOLDER')}
              value={searchText}
              onChange={event => onSearchTextChange(event.target.value)}
            />
            {searchText && (
              <button
                type="button"
                className="quick-list-clear-search"
                data-testid="btn-clear-filters"
                aria-label={t('QUICK_LIST_SETTINGS.LIST.CLEAR_SEARCH')}
                title={t('QUICK_LIST_SETTINGS.LIST.CLEAR_SEARCH')}
                onClick={handleClearSearch}>
                <FontAwesomeIcon icon={faTimes} aria-hidden="true" />
              </button>
            )}
          </div>
        </Col>
        <Col
          md={6}
          lg={2}
          className="quick-list-status-filter"
          data-testid="container-status-filter">
          <label htmlFor="quick-list-status-toggle">
            {status
              ? t('QUICK_LIST_SETTINGS.FORM.ACTIVE')
              : t('QUICK_LIST_SETTINGS.FORM.INACTIVE')}
          </label>
          <div className="toggle">
            <label className="switch">
              <input
                id="quick-list-status-toggle"
                type="checkbox"
                checked={!!status}
                disabled={loading}
                onChange={() => onStatusChange(!status)}
                data-testid="input-status-filter"
              />
              <span className="slider round"></span>
            </label>
          </div>
        </Col>
        <Col md={12} lg={6} className="quick-list-filter-actions">
          <button
            type="button"
            data-testid="btn-add-quick-list"
            onClick={onCreate}
            className="btn-add btn-add-quick-list">
            <FontAwesomeIcon icon={faPlus} />
            {t('QUICK_LIST_SETTINGS.LIST.ADD')}
          </button>
          <button
            type="button"
            data-testid="btn-toggle-bulk-upload"
            disabled={loading || bulkOperationInProgress}
            onClick={onToggleBulkUpload}
            className="btn-add btn-bulk-upload">
            <FontAwesomeIcon icon={faUpload} />
            {t('QUICK_LIST_SETTINGS.BULK_UPLOAD.BUTTON')}
          </button>
        </Col>
      </Row>
    </div>
  )
}

export default QuickListFilters
